import { useState } from 'react';
import { AAIT_PORTFOLIO_URL } from '@/constants/aaitSite';
import { portfolioData } from '@/mocks/landingSitesData';

function PortfolioCard({ item }: { item: (typeof portfolioData)[number] }) {
  const [imgError, setImgError] = useState(false);

  const scrollToCta = () => {
    document.querySelector('#cta')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <article className="group flex flex-col h-full v2-glass-card rounded-3xl overflow-hidden border border-white/10 hover:border-teal-400/30 hover:shadow-[0_0_40px_-12px_rgba(45,212,191,0.35)] transition-all duration-500">
      <button
        type="button"
        onClick={scrollToCta}
        className="flex flex-col h-full text-right focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-400/60 focus-visible:ring-inset"
      >
        <div
          className={`relative h-52 sm:h-56 md:h-60 overflow-hidden bg-gradient-to-b ${item.imageBg}`}
        >
          <div className="absolute inset-0 v2-grid-pattern opacity-20" />
          <div className="absolute inset-0 flex items-center justify-center p-5 sm:p-6">
            {!imgError ? (
              <img
                src={item.image}
                alt={item.title}
                loading="lazy"
                decoding="async"
                onError={() => setImgError(true)}
                className="max-h-full max-w-full w-auto h-auto object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.45)] group-hover:scale-[1.04] transition-transform duration-500 ease-out"
              />
            ) : (
              <i className="ri-global-line text-6xl text-teal-400/30" />
            )}
          </div>
          <span className="absolute top-3 right-3 bg-[#030712]/70 backdrop-blur-md border border-teal-400/25 text-teal-200 text-[11px] font-semibold px-3 py-1 rounded-full">
            {item.category}
          </span>
        </div>

        <div className="flex flex-col flex-1 p-5 md:p-6 border-t border-white/5 bg-[#030712]/40">
          <h3 className="text-lg md:text-xl font-bold text-white mb-1.5 group-hover:text-teal-100 transition-colors">
            {item.title}
          </h3>
          <p className="text-slate-400 text-sm leading-relaxed mb-4 flex-1">
            {item.description}
          </p>
          <span className="inline-flex items-center gap-2 text-teal-400 text-sm font-semibold mt-auto">
            اطلب موقعًا مشابهًا
            <span className="w-8 h-8 rounded-full bg-teal-500/15 border border-teal-400/20 flex items-center justify-center group-hover:bg-teal-500/25 transition-colors">
              <i className="ri-arrow-left-line text-base group-hover:-translate-x-0.5 transition-transform" />
            </span>
          </span>
        </div>
      </button>
    </article>
  );
}

export default function Portfolio() {
  return (
    <section
      id="portfolio"
      className="section-padding relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-teal-500/[0.07] via-transparent to-transparent pointer-events-none" />

      <div className="container-main relative">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 md:mb-12">
          <div className="max-w-xl">
            <span className="v2-section-label">
              <span className="w-8 h-px bg-teal-400" />
              أعمالنا
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mt-4">
              <span className="title-line-1">نماذج من</span>
              <span className="title-line-2 v2-gradient-text">مواقعنا</span>
            </h2>
            <p className="text-slate-400 text-sm md:text-base leading-relaxed mt-4">
              مشاريع حقيقية من معرض أوامر الشبكة — مواقع تعريفية، مؤسسية، ومنصات
              خدمات لقطاعات متنوعة في السعودية.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <a
              href="#cta"
              onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector('#cta')
                  ?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="v2-cta-primary text-sm py-3 px-6 justify-center"
            >
              <i className="ri-global-line" />
              اطلب موقعك
            </a>
            <a
              href={AAIT_PORTFOLIO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 text-teal-400 font-semibold border border-teal-400/30 rounded-full px-6 py-3 hover:bg-teal-500/10 transition-colors text-sm"
            >
              شاهد المزيد
              <i className="ri-external-link-line" />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {portfolioData.map((item) => (
            <PortfolioCard key={item.title} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
